import React from "react";
import "./App.css";
import AppRoutes from "./routes/routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FirstUrlProvider } from "./Context/FirstUrlContext";
import { PageTitleProvider } from "./Context/PageTitleContext";

function App() {
  return (
    <div style={{ height: "100%" }}>
      <FirstUrlProvider>
        <PageTitleProvider>
          <AppRoutes />
        </PageTitleProvider>
      </FirstUrlProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
